import clsx from 'clsx';
import React from 'react';

interface Props {
	children: React.ReactNode;
	paddingClassName?: string;
	className?: string;
}

const ScrollableCard = ({ children, className, paddingClassName = 'p-4' }: Props) => {
  return (
    <div
      className={clsx(
        'max-h-full overflow-hidden bg-white rounded-xl shadow-xl flex flex-col',
        className,
        paddingClassName
      )}
    >
      {children}
    </div>
  );
};

const Header: React.FC<{ className?: string }> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

const Body: React.FC<{ className?: string; maxHeightClassName?: string }> = ({
  children,
  className,
  maxHeightClassName
}) => (
  <div
    className={clsx(
      'flex-1 overflow-hidden overflow-y-auto',
      className,
      maxHeightClassName || 'h-full max-h-full'
    )}
  >
    {children}
  </div>
);

ScrollableCard.Header = Header;
ScrollableCard.Body = Body;

export { ScrollableCard as default };
